import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";
import ICONS from "../../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { clearSchedulesTxnErrors } from "../../../../../redux/features/scheduleTransaction";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";

const ScheduleBeneficiaryMultiApprovalFailed = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [ErrorPageData, setErrorPageData] = useState([]);

  const { schedulesTxnApprovalError, schedulesTxnRejectError } = useSelector(
    (state) => state.schedulesTxn,
  );
  const actionType =
    schedulesTxnRejectError && !schedulesTxnApprovalError
      ? "reject"
      : schedulesTxnApprovalError && !schedulesTxnRejectError
        ? "approve"
        : "approve";

  const findCommonNames = (arr1, arr2) => {
    let type = arr2.some((item) => typeof item === "string");
    if (type) {
      return arr2;
    } else {
      const arr2Map = new Map(arr2?.map((item) => [item?.id, item?.errors]));

      return arr1
        .filter((item) => arr2Map?.has(item.txn_id))
        .map((item) => ({
          ...item,
          errors: arr2Map?.get(item.txn_id),
        }));
    }
  };
  const filterErrorTxn = findCommonNames(
    ErrorPageData,
    JSON.parse(sessionStorage.getItem("ScheduleDataError")) || [],
  );

  const buttonRows = [
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/beneficiary_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const getTitle = () => {
    return actionType === "reject"
      ? "Oops! Schedules rejection failed"
      : "Oops! Schedules approval failed";
  };

  const getSubtitle = () => {
    const action = actionType === "reject" ? "rejection" : "approval";
    return `An error occurred with the following schedules, causing the ${action} of all the schedules to fail.`;
  };

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
      dispatch(clearSchedulesTxnErrors());
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedscheduleData"),
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);

  return (
    <div>
      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title={getTitle()}
        subtitle={getSubtitle()}
      >
        <TabsWeapperSection title="Error details">
          <>
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (
                  typeof val === "string" &&
                  val.includes("No transactions found for transaction ids")
                ) {
                  return (
                    <InfoCard
                      bgColor="var(--negative-card)"
                      key={i}
                      rows={[
                        {
                          leftTitle: val,
                          leftSubTitle: "Error message",
                        },
                      ]}
                    />
                  );
                }
                return (
                  <>
                    {val.errors?.map((error, index) => (
                      <InfoCard
                        bgColor="var(--negative-card)"
                        key={index}
                        rows={[
                          {
                            leftTitle: error?.reason || error,
                            leftSubTitle: "Error message",
                          },
                        ]}
                      />
                    ))}
                  </>
                );
              })}
          </>
        </TabsWeapperSection>
        <TabsWeapperSection title="Schedules Details">
          <>
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (typeof val === "string") return null;
                return (
                  <InfoCard
                    key={val.txn_id || i}
                    bgColor="var(--negative-card)"
                    onClick={() =>
                      navigate(
                        `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${val?.txn_id}`,
                      )
                    }
                    hoverable="white"
                    rows={[
                      {
                        leftTitle: val.scheduled_name,
                        leftSubTitle: "Schedule name",
                        hasRight: true,
                        rightText: true,
                        rightTitle: (
                          <>
                            INR <FormatAmount price={val?.amount} />
                          </>
                        ),
                        rightTitleTextColor: "var(--text-primary)",
                        rightTextFontWeight: "semibold",
                        rightSubTitle: "Amount",
                        rightIcon: true,
                      },
                    ]}
                  />
                );
              })}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default ScheduleBeneficiaryMultiApprovalFailed;
